import React, {Component} from 'react'
import PropTypes from "prop-types"
import {connect} from 'react-redux'
import {reduxForm, Field} from 'redux-form'
import {IMPORT_EXPORT_QUESTIONS_MODAL, hideModal} from '../../../modules/modals'
import {exportListSelector, exportSubmit, changeQuestionsStatuses, QUESTION_STATUSES} from '../../../modules/questions'
import {checkedCategoriesIdsSelector} from "../../../modules/categories"
import {
    successExportMsg,
    labelExportName,
    okExportText,
    cancelExportText,
    exportFormName,
    checkImportExportMenuDataItem,
    exportId,
    exportDocxId,
    exportPdfId
} from '../../../helpers/importExport'
import RenderInputFormGroup from '../../common/Form/RenderInputFormGroup'
import {findDOMNode} from "react-dom"
import {showLoading, hideLoading} from 'react-redux-loading-bar'
import {downloadFile} from '../../../helpers/common'
import './ExportForm.scss';
import { required } from 'redux-form-validators'

class ExportForm extends Component {
    render() {
        const {submitSucceeded, error, submitting, onCancelClick, exportList, what} = this.props
        const {formatMessage} = this.context
        return (
            <form onSubmit={this._handleSubmit} className="create-dialog-form">
                <Field
                    name = "name"
                    id = "name"
                    type = "text"
                    component = {RenderInputFormGroup}
                    label = {formatMessage(labelExportName)}
                    ref = {this.getFieldRef}
                    validate={[required()]}
                />

                {/* <div className="checkbox">
                    <label>
                        <Field
                            type="checkbox"
                            component='input'
                            className="form-check-input"
                            id="mark_exported"
                            name="mark_exported"
                        />
                        {formatMessage('Mark proceded questions as exported')}
                    </label>
                </div> */}

                <div className="radio">
                    <Field
                        component={this.RadioField}
                        className="form-radio-input"
                        id="mark_exported"
                        name="statusQuestion"
                    />
                </div>


                {
                    [exportDocxId, exportPdfId].includes(what) && (
                        <div className="row mb-3">
                            <div className="col-xs-12 col-sm-8 flex flex-align-center" style={{minHeight:34}}>{formatMessage('multipleExamVariants')}</div>
                            <div className="col-xs-12 col-sm-4">
                                <Field
                                    component='select'
                                    className="form-control"
                                    id="exemplars"
                                    name="exemplars"
                                >
                                    {
                                        Array.from({length: 10}, (v, k) => k+1).map(index => (
                                            <option key={index} value={index}>{index}</option>
                                        ))
                                    }
                                </Field>
                            </div>
                        </div>
                    )
                }

                {
                    submitSucceeded &&
                    <div className="row mb-3">
                        <div className="col-xs-12 text-center text-success">{formatMessage(successExportMsg)}</div>
                    </div>
                }
                {
                    !exportList.length &&
                    <div className="row mb-3">
                        <div className="col-xs-12 text-center text-danger">{formatMessage('No question for export selected.')}</div>
                    </div>
                }
                {
                    error &&
                    <div className="row mb-3">
                        <div className="col-xs-12 text-center text-danger">{formatMessage(error)}</div>
                    </div>
                }
                <div className="create-dialog-form__group flex">
                    <button
                        disabled={submitting || !exportList.length}
                        className="btn btn-primary mr-auto"
                        type="submit"
                    >{formatMessage(okExportText)}</button>
                    <button
                        onClick={onCancelClick}
                        className="btn btn-warning"
                        type="button"
                    >{formatMessage(cancelExportText)}</button>
                </div>
            </form>
        )
    }

    _handleSubmit = (event) => {
        event.preventDefault()
        let {handleSubmit, onSubmit, what} = this.props
        handleSubmit(onSubmit(what))()
    }

    RadioField = ({input}) => {
        return <div className="radio-button-grout-status">
            <label>
                <input type="radio" onChange={() => {input.onChange(3)}} checked={input.value == 3}/>
                <div className="item used">Used</div>
            </label>
            <label>
                <input type="radio" onChange={() => {input.onChange(1)}} checked={input.value == 1}/>
                <div className="item read">Ready to use</div>
            </label>
            <label>
                <input type="radio" onChange={() => {input.onChange(2)}} checked={input.value == 2}/>
                <div className="item unused">Unused</div>
            </label>
        </div>
    }

    componentDidMount() {
        this.setFocus()
    }
    getFieldRef = ref => {
        if (ref) this.input = findDOMNode(ref).querySelector('input')
    }
    setFocus = () => this.input && this.input.focus()

    static contextTypes = {formatMessage: PropTypes.any}
}

export default connect(
    state => {
        const checkedCategoriesIds = checkedCategoriesIdsSelector(state)
        const exportList = exportListSelector(state, checkedCategoriesIds)
        return {
            exportList,
            initialValues : {
                list : exportList.map(question => question.id),
                mark_exported : true,
                exemplars : 1,
                statusQuestion: 3,
            }
        }
    },
)(reduxForm({
    form : exportFormName,
    onSubmit : (what) => (values, dispatch) => {

        let {mark_exported, list, name, exemplars, statusQuestion} = values
        dispatch(showLoading('modal'))

        if (!checkImportExportMenuDataItem(exportId, what)) return

        name = name.replace(/&/g, '_');

        let submit = exportSubmit({list, name, flag : +mark_exported, what, exemplars, statusQuestion})
                .then(result => {
                    const {redirectTo} = result

                    if (!redirectTo) return

                    downloadFile(redirectTo)
                })
                .then(() => {
                    dispatch(hideModal({modalType : IMPORT_EXPORT_QUESTIONS_MODAL}))

                    let status = !!mark_exported ? statusQuestion : QUESTION_STATUSES[2].status
                    dispatch(changeQuestionsStatuses({
                        changeData : list.map(questionId => ({questionId, status}))
                    }))
                })
                .finally(() => {
                    dispatch(hideLoading('modal'))
                })
        return submit
    },

})(ExportForm))


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/modals/ImportExport/ExportForm.js